import gql from 'graphql-tag';

export const mutationCreateStripeCheckoutSession = gql`
  mutation createStripeCheckoutSession(
    $subscriptionDuration: SubscriptionDuration!
  ) {
    createStripeCheckoutSession(
      subscriptionDuration: $subscriptionDuration
    )
  }
`;
export default mutationCreateStripeCheckoutSession;
